// ** Third Party Components
import styled, { css } from "styled-components";

// ####################################################

export const StyledMessage = styled.div`
	display: flex;
	flex-direction: column;

	background-color: ${({ theme: { colors } }) => colors.buttonsDefaultGrey};

	${({ isRightSide }) =>
		isRightSide &&
		css`
			background-color: ${({ theme: { isDarkMode } }) =>
				isDarkMode ? "#303030" : "#eaeaea"};
		`}

	padding: 0.75rem;
	border-radius: ${({ theme: { borderRadius } }) => borderRadius.messages};
	word-break: break-word;
`;

// ####################################################
